// Shapes returned by lpg/getLpgPage, which is lpg_page_v1 (db/migrations/0384).
// Every figure is Postgres's; nothing here computes one. Numbers arrive as
// numbers or numeric strings, so the page formats through the loans helpers.
export { formatDay, formatZar } from './loans'

export type LpgCar = {
  id: string
  vehicle_id: string
  plate: string
  make: string | null
  model: string | null
  started_on: string
  ended_on: string | null
  km_per_litre_standard: number | string
  standard_reason: string | null
  notes: string | null
  end_reason: string | null
  recorded_by: string | null
  recorded_at: string
  period: {
    shifts: number
    kilometres: number | string | null
    litres: number | string | null
    km_per_litre: number | string | null
    cost_zar: number | string | null
    value_saved_zar: number | string | null
  }
  slips: {
    lpg_lines: number
    lpg_litres: number | string | null
    lpg_amount_zar: number | string | null
    other_lines: number
    other_litres: number | string | null
    declared_litres: number | string | null
  }
}

export type LpgDriver = {
  driver_id: string
  name: string
  shifts: number
  kilometres: number | string
  litres: number | string
  litres_standard: number | string
  km_per_litre: number | string | null
  adjustment_zar: number | string
  saving_share_zar: number | string
  pool_adjustment_zar: number | string
  l_per_100km: number | string | null
  standard_l_per_100km: number | string | null
  tolerance_l_per_100km: number | string | null
  above_tolerance: boolean
  performance_eligible: boolean
}

export type LpgPage = {
  can_edit: boolean
  today: string
  period: { start: string; end: string }
  policy: { default_km_per_litre: number | string; driver_saving_share: number | string; tolerance_pct: number | string } | null
  price: { price: number | string; station: string; effective_from: string } | null
  prices: { effective_from: string; effective_to: string | null; price: number | string; station: string; recorded_by: string | null }[]
  cars: LpgCar[]
  drivers: LpgDriver[]
  vehicles: { id: string; plate: string; make: string | null; model: string | null; on_lpg: boolean }[]
}

/** A number for display, or the no-value mark. Never a zero standing in for a missing figure. */
export function formatNum(v: number | string | null | undefined, digits = 1): string {
  if (v === null || v === undefined || v === '') return '—'
  const n = Number(v)
  if (!Number.isFinite(n)) return '—'
  return n.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits })
}

/** 20.00 reads as 20, 18.50 as 18.5. */
export function formatKmpl(v: number | string | null | undefined): string {
  if (v === null || v === undefined || v === '') return '—'
  const n = Number(v)
  return Number.isFinite(n) ? `${Number(n.toFixed(2))} km/l` : '—'
}

export function toNumber(v: number | string | null | undefined): number | null {
  if (v === null || v === undefined || v === '') return null
  const n = Number(v)
  return Number.isFinite(n) ? n : null
}
